import office from '@/taskpane/officejs/office-wrapper'
import state from '@/taskpane/state/sidebar-state'
import broadcastMessageToPortals from './broadcast-message-to-portals'
import PersonInfo from '../models/person-info'
import EventInfo from '../models/event-info'
import CallbackArgs, { defaultCallbackArgs } from './callback-args'
import { observeEventComposeChanges } from '../observers/observe-compose-changes'

export interface EventItemOpenArgs extends CallbackArgs {
  people: PersonInfo[]
  eventInfo: EventInfo
  linkedIds: string[]
  globalId: string
  owner: string
  isEmailInvitation: boolean
}

export default async function sendEventItemOpenMessage() {
  const eventArgs = await getEventItemOpenArgs()
  if (eventArgs) {
    await broadcastMessageToPortals('EventItemOpen', eventArgs)
    state.currentItem.initialItemOpenSent = true
  }

  if (office.mode.isCompose() && !state.currentItem.composeInfo.observersInitialized) {
    await observeEventComposeChanges(eventArgs)
  }
}

function isLocalMidnight(date: Date) {
  return date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0
}

async function getEventItemOpenArgs(): Promise<EventItemOpenArgs> {
  if (!Office.context.mailbox.item) {
    return null
  }

  const [attendees, body, subject, attachments, categories, start, end, location, owner, id] = await Promise.all([
    office.people.get(),
    office.body.get(true, null),
    office.subject.get(),
    office.attachments.get(),
    office.categories.get(),
    office.event.start(),
    office.event.end(),
    office.event.location(),
    office.event.owner(),
    office.id(),
  ])

  const isAllDayEvent = isLocalMidnight(start) && isLocalMidnight(end) && end.getDate() != start.getDate()
  const time = await office.event.time(isAllDayEvent)

  return {
    ...defaultCallbackArgs(),
    people: attendees,
    linkedIds: [],
    owner: owner || state.userEmail,
    globalId: id,
    isEmailInvitation: office.mode.isMessage(),
    eventInfo: {
      attachments: attachments,
      description: body.replace(/<meta\/?[^>]+(>|$)/g, ''),
      isAllDay: isAllDayEvent,
      location: location,
      time: time,
      title: subject,
      categories: categories,
      uid: '',
      iCalUId: '',
    },
  }
}
